import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import MainToolbar from '@/components/MainToolbar.vue';
import FragmentModal from '@/components/FragmentModal.vue';
import { namespace } from 'vuex-class';
const uiModule = namespace('ui');
const dataVersionsModule = namespace('dataVersions');
let App = class App extends Vue {
    constructor() {
        super(...arguments);
        this.isDataLoaded = false;
    }
    created() {
        this.fetchDataVersions().then(() => { this.isDataLoaded = true; });
    }
};
__decorate([
    uiModule.State
], App.prototype, "isDarkSide", void 0);
__decorate([
    dataVersionsModule.State
], App.prototype, "hasInternet", void 0);
__decorate([
    dataVersionsModule.Action
], App.prototype, "fetchDataVersions", void 0);
App = __decorate([
    Component({
        components: {
            MainToolbar,
            FragmentModal
        }
    })
], App);
export default App;
